import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Button,
  Modal,
  Col,
  Form,
  FormControl,
  FormGroup,
  Panel
} from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead';
//import Autocomplete from 'react-autocomplete';
//import Suggest from '../suggest'
import { browserHistory } from 'react-router'
import Validators from '../../utils/validators'
import CountriesDropdown from '../countriesdropdown'
import StatesDropdown from '../statesdropdown'
import ProvincesDropdown from '../provincesdropdown'
import Dropdown from '../dropdown'

@observer(['activities', 'companies', 'users', 'categories', 'sources', 'vendors', 'globals'])
export default class NewCompanyForm extends Component {

  constructor(props) {
    super(props)

    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))
    //this.props.industries.loadAllIndustriesWithCategories()
    this.props.categories.loadAllCategories()
    this.props.sources.loadAllSources()
    this.props.vendors.loadAllVendors()

    this.state = {
      newCompanyName: '',
      newUserId: '',
      newSourceId: '',
      newVendorId: '',
      newCategoryId: '',
      newCompanyContactTitle: '',
      newCompanyContactFirstName: '',
      newCompanyContactLastName: '',
      newCompanyContactEmail: '',
      newCompanyContactPhone: '',
      newCompanyContactAddress: '',
      newCompanyContactCity: '',
      newState: 'AL',
      newCompanyContactZipCode: '',
      newCompanyContactCountry: 'United States',
      newCompanySalesNote: ''
    }
  }

  closeNewCompanyForm() {
    this.props.onClose()

    this.setState({
      newCompanyName: '',
      newUserId: '',
      newSourceId: '',
      newVendorId: '',
      newCategoryId: '',
      newCompanyContactTitle: '',
      newCompanyContactFirstName: '',
      newCompanyContactLastName: '',
      newCompanyContactEmail: '',
      newCompanyContactPhone: '',
      newCompanyContactAddress: '',
      newCompanyContactCity: '',
      newState: 1,
      newCompanyContactZipCode: '',
      newCompanyContactCountry: 'United States',
      newCompanySalesNote: ''
    })
  }

  reloadCategories() {
    this.props.categories.loadAllIndustryCategories(document.getElementById('industryDropdown').value)
  }

  validateForm() {
    if (this.getNewUserIdValidationState() == 'error') {
      return false
    }

    if (this.getNewSourceIdValidationState() == 'error') {
      return false
    }

    if (this.getNewVendorIdValidationState() == 'error') {
      return false
    }

    if (this.getNewCategoryIdValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyNameValidationState() == 'error') {
      return false
    }
    /*
    if (this.getNewCompanyContactTitleValidationState() == 'error') {
      return false
    }
    */
    if (this.getNewCompanyContactFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactLastNameValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactEmailValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactPhoneValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactAddressValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactCityValidationState() == 'error') {
      return false
    }

    if (this.getNewCompanyContactZipCodeValidationState() == 'error') {
      return false
    }

    return true
  }

  getNewUserIdValidationState() {
    if (Validators.validString(this.state.newUserId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewSourceIdValidationState() {
    if (Validators.validString(this.state.newSourceId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewVendorIdValidationState() {
    if (Validators.validString(this.state.newVendorId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCategoryIdValidationState() {
    if (Validators.validString(this.state.newCategoryId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyNameValidationState() {
    if (Validators.validString(this.state.newCompanyName)) {
      return 'success'
    } else {
      return 'error'
    }
  }
  /*
  getNewCompanyContactTitleValidationState() {
    if (Validators.validString(this.state.newCompanyContactTitle)) {
      return 'success'
    } else {
      return 'error'
    }
  }
  */
  getNewCompanyContactFirstNameValidationState() {
    if (Validators.validString(this.state.newCompanyContactFirstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactLastNameValidationState() {
    if (Validators.validString(this.state.newCompanyContactLastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactEmailValidationState() {
    if (Validators.validEmail(this.state.newCompanyContactEmail)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactPhoneValidationState() {
    if (Validators.validString(this.state.newCompanyContactPhone)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactAddressValidationState() {
    if (Validators.validString(this.state.newCompanyContactAddress)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactCityValidationState() {
    if (Validators.validString(this.state.newCompanyContactCity)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewCompanyContactZipCodeValidationState() {
    if (Validators.validString(this.state.newCompanyContactZipCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  newCompanyNameChanged(e) {
    this.setState({
      newCompanyName: e.target.value
    })
  }

  newCompanyContactTitleChanged(e) {
    this.setState({
      newCompanyContactTitle: e.target.value
    })
  }

  newCompanyContactFirstNameChanged(e) {
    this.setState({
      newCompanyContactFirstName: e.target.value
    })
  }

  newCompanyContactLastNameChanged(e) {
    this.setState({
      newCompanyContactLastName: e.target.value
    })
  }

  newCompanyContactEmailChanged(e) {
    this.setState({
      newCompanyContactEmail: e.target.value
    })
  }

  newCompanyContactPhoneChanged(e) {
    this.setState({
      newCompanyContactPhone: e.target.value
    })
  }

  newCompanyContactAddressChanged(e) {
    this.setState({
      newCompanyContactAddress: e.target.value
    })
  }

  newCompanyContactCityChanged(e) {
    this.setState({
      newCompanyContactCity: e.target.value
    })
  }

  newCompanyContactZipCodeChanged(e) {
    this.setState({
      newCompanyContactZipCode: e.target.value
    })
  }

  newCompanyContactCountryChanged(e) {
    this.setState({
      newCompanyContactCountry: e.target.value
    })
  }

  newCompanySalesNoteChanged(e) {
    this.setState({
      newCompanySalesNote: e.target.value
    })
  }

  onSourceChanged(e) {
    if (e.length > 0) {
      this.setState({
        newSourceId: e[0].id
      })
    } else {
      this.setState({
        newSourceId: ''
      })
    }
  }

  onUserChanged(e) {
    if (e.length > 0) {
      this.setState({
        newUserId: e[0].id
      })
    } else {
      this.setState({
        newUserId: ''
      })
    }
  }

  onVendorChanged(e) {
    if (e.length > 0) {
      this.setState({
        newVendorId: e[0].id
      })
    } else {
      this.setState({
        newVendorId: ''
      })
    }
  }

  onCategoryChanged(e) {
    if (e.length > 0) {
      this.setState({
        newCategoryId: e[0].id
      })
    } else {
      this.setState({
        newCategoryId: ''
      })
    }
  }

  onStateChanged(e) {
    this.setState({
      newState: e.target.value
    })
  }

  newCompany(e) {
    const data = {
      name: this.state.newCompanyName,
      companyStateId: this.props.companyStateId,
      organizationId: this.props.globals.loggedInUser.organizationId,
      sourceId: this.state.newSourceId,
      vendorId: this.state.newVendorId,
      title: this.state.newCompanyContactTitle,
      firstName: this.state.newCompanyContactFirstName,
      lastName: this.state.newCompanyContactLastName,
      email: this.state.newCompanyContactEmail,
      phone: this.state.newCompanyContactPhone,
      address: this.state.newCompanyContactAddress,
      city: this.state.newCompanyContactCity,
      state: this.state.newState,
      zipCode: this.state.newCompanyContactZipCode,
      country: this.state.newCompanyContactCountry,
      categoryId: this.state.newCategoryId,
      userId: this.state.newUserId,
      salesNote: this.state.newCompanySalesNote,
      hash: localStorage.getItem('userHash')
    }

    if (this.validateForm()) {
      this.props.companies.newCompany(data, (data) => {
        const newUrl = '/company/details/' + data.addCompany.id
        if (newUrl == window.location.pathname) {
          if (this.props.refreshCompanyDetails) {
            this.props.refreshCompanyDetails()
          } else {
            console.log('ERROR: Could not refresh details! Refresh method not found in props.');
          }
        } else {
          console.log('navigating to: ', newUrl)
          browserHistory.push(newUrl)
        }

        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 4, data.addCompany.id, 3, localStorage.getItem('userOrganizationId'))
      })
      this.closeNewCompanyForm()
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  render() {
    const stateDropdown = (this.state.newCompanyContactCountry == 'United States')
    ? (
      <Col sm={4}><StatesDropdown id="newState" onChange={this.onStateChanged.bind(this)} /></Col>
    ) : (
      <Col sm={4}><ProvincesDropdown id="newState" onChange={this.onStateChanged.bind(this)} /></Col>
    );

    return (
      <Modal show={this.props.showNewCompanyForm} onHide={this.closeNewCompanyForm.bind(this)} >
        <Modal.Header closeButton>
          <Modal.Title>New {this.props.companyTypeHeading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal name="newCompanyForm">
            <Panel header={<h3>Company Information</h3>}>
              <FormGroup>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCompanyNameValidationState()}>
                    <FormControl type="text" placeholder="Company Name" id="newCompanyName" onChange={this.newCompanyNameChanged.bind(this)} />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewUserIdValidationState()}>
                    <Typeahead clearButton labelKey="name" options={this.props.users.all} onChange={this.onUserChanged.bind(this)} placeholder="Choose a user..." />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCategoryIdValidationState()}>
                    <Typeahead clearButton labelKey="name" options={this.props.categories.data} onChange={this.onCategoryChanged.bind(this)} placeholder="Choose a industry..." />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewSourceIdValidationState()}>
                    <Typeahead clearButton labelKey="name" options={this.props.sources.data} onChange={this.onSourceChanged.bind(this)} placeholder="Choose a source..." />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup validationState={this.getNewVendorIdValidationState()}>
                <Col sm={6}><Typeahead clearButton labelKey="name" options={this.props.vendors.data} onChange={this.onVendorChanged.bind(this)} placeholder="Choose a vendor..." /></Col>
              </FormGroup>
            </Panel>
            <Panel header={<h3>Contact Information</h3>}>
              { /* <FormGroup validationState={ this.getNewCompanyContactTitleValidationState() }> */}
              <FormGroup>
                <Col sm={12}><FormControl type="text" placeholder="Title" id="newContactTitle" onChange={this.newCompanyContactTitleChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCompanyContactFirstNameValidationState()}>
                    <FormControl type="text" placeholder="Contact First Name" id="newContactFirstName" onChange={this.newCompanyContactFirstNameChanged.bind(this)} />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCompanyContactLastNameValidationState()}>
                    <FormControl type="text" placeholder="Contact Last Name" id="newContactLastName" onChange={this.newCompanyContactLastNameChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCompanyContactEmailValidationState()} >
                    <FormControl type="text" placeholder="Email" id="newContactEmail" onChange={this.newCompanyContactEmailChanged.bind(this)} />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup validationState={this.getNewCompanyContactPhoneValidationState()} >
                    <FormControl type="text" placeholder="Phone" id="newContactPhone" onChange={this.newCompanyContactPhoneChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup validationState={this.getNewCompanyContactAddressValidationState()} >
                <Col sm={12}><FormControl type="text" placeholder="Address" id="newAddress" onChange={this.newCompanyContactAddressChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={4}>
                  <FormGroup validationState={this.getNewCompanyContactCityValidationState()} >
                    <FormControl type="text" placeholder="City" id="newCity" onChange={this.newCompanyContactCityChanged.bind(this)} />
                  </FormGroup>
                </Col>
                { stateDropdown }
                <Col sm={4}>
                  <FormGroup validationState={this.getNewCompanyContactZipCodeValidationState()} >
                    <FormControl type="text" placeholder="Zip Code" id="newZipCode" onChange={this.newCompanyContactZipCodeChanged.bind(this)} />
                  </FormGroup>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><CountriesDropdown id="newCountry" defaultValue={this.state.newCompanyContactCountry} onChange={this.newCompanyContactCountryChanged.bind(this)} /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}><FormControl componentClass="textarea" placeholder="Sales Note" id="newSalesNote" onChange={this.newCompanySalesNoteChanged.bind(this)} /></Col>
              </FormGroup>
            </Panel>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.closeNewCompanyForm.bind(this)}><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
          <Button bsStyle="success" onClick={this.newCompany.bind(this)}><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/companies/newcompanyform.js